import listSaga from './listSaga'
import loginSaga from './loginSaga'
import getUserIdByContactSagaTask from './getUserIdByContact'

const chatDetailsSagas = [listSaga(), loginSaga(), getUserIdByContactSagaTask()]

export default chatDetailsSagas
